import React, {Component} from 'react';
import Slider from "react-slick";
import ApartmentBox from "./ApartmentBox";
import Preloader from "@assets/js/elements/components/Preloader";
import {CONFIG} from "../../common/config";
import '@assets/sass/components/recommended.scss';
import {getTranslations} from "@assets/js/functions/helpers";
import qs from 'query-string'
import { createBrowserHistory } from 'history';
let history = createBrowserHistory();

let queryParamsParsed = qs.parse(window.location.search, {arrayFormat: 'bracket'});

function NextArrow(props) {
  const {onClick} = props;
  return <span className="arrow arrow-next" onClick={onClick}/>
}

function PrevArrow(props) {
  const {onClick} = props;
  return <span className="arrow arrow-prev" onClick={onClick}/>
}

export default class RecommendedApartments extends Component {

  state = {
    categories: [],
    apartments: [],
    category: 0,
    isLoadingResults: true,
    fetchError: false,
    query: '',
    queryParamsParsed: queryParamsParsed
  }

  constructor(props) {
    super(props);

    setInterval(this.getLocationAndUpdateApartments, 5000)

  }

  componentDidMount() {
    if (this.props.meta) {
      this.state.queryParamsParsed.meta = this.props.meta;
    }

    this.setState({
      query: '?' + qs.stringify(this.state.queryParamsParsed)
    })

    setTimeout(this.getCategories, 1000)

  }

  getLocationAndUpdateApartments = () =>{
    let newHistory = createBrowserHistory();

    if (history.location.search !== newHistory.location.search){
      history = newHistory;

      //todo update parsed query data
      this.state.queryParamsParsed= {...this.state.queryParamsParsed, ...history.location.state};
      // console.log('Refreshing with parameters this.state.queryParamsParsed.concat: ', this.state.queryParamsParsed);
      this.state.query = '?' + qs.stringify(this.state.queryParamsParsed);
      // console.log('Refreshing with parameters this.state.queryParamsParsed.concat query: ', this.state.query);

      //refresh data
      this.getApartments(this.state.category);
    }
  }

  getCategories = () => {
    try {
      fetch(CONFIG.GET_APARTMENT_ADS_CATEGORIES + this.state.query, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return response.json()
      }).then(body => {
        let category = 0
        body.categories.map((cat, i) => {
          if (this.props.category) {
            if (parseInt(this.props.category) === cat.id) {
              category = i
              cat.is_active = true
            } else {
              cat.is_active = false
            }
          }
        })
        this.setState({
          categories: body.categories,
          category: category,
          fetchError: false,
        })
        this.getApartments(body.categories[category].id)
      }).catch(error => {
        this.setState({
          fetchError: true,
          isLoadingResults: false,
        });
      })
    } catch (error) {
    }
  }

  getApartments = (category) => {
    if (this.props.cityName) {
      this.getAppartmentsByCityName();
    } else {
      this.getAppartmentsByCategory(category);
    }
  }

  getAppartmentsByCategory = (category) => {
    try {
      fetch(CONFIG.GET_APARTMENT_ADS + category + this.state.query, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return response.json()
      }).then(body => {
        this.setState({
          apartments: body.apartments,
          isLoadingResults: false
        })
      }).catch(error => {
        this.setState({
          fetchError: true,
          isLoadingResults: false,
        });
      })
    } catch (error) {
    }
  }

  getAppartmentsByCityName = () => {
    try {
      fetch(CONFIG.GET_APARTMENT_ADS_BY_CITY_NAME + this.props.cityName + this.state.query, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return response.json()
      }).then(body => {
        this.setState({
          apartments: body.apartments,
          isLoadingResults: false
        })
      }).catch(error => {
        this.setState({
          fetchError: true,
          isLoadingResults: false,
        });
      })
    } catch (error) {
    }
  }


  changeCategory = (category) => {
    let categories = this.state.categories
    this.state.categories.map((category, j) => {
      categories[j].is_active = false
    })
    categories[category].is_active = true
    this.setState({
      categories,
      category,
      isLoadingResults: true,
    })
    this.getApartments(categories[category].id)
  }

  renderCategories = (translations) => {
    if (this.props.hideCategoriesButtons && this.props.hideCategoriesButtons === true) {
      return;
    }

    return this.state.categories.map((category, i) => {
      const lang = document.documentElement.lang;
      let name;

      switch (lang) {
        default:
        case "pl":
          name = category.name;
          break;
        case "en":
          name = category.name_en;
          break;
        case "de":
          name = category.name_de;
          break;
      }

      return <button
        className={"category" + (category.is_active ? " category-active" : "") + " translation-key" + category.id}
        onClick={() => this.changeCategory(i)}
        key={category.id}
      >
        {name}
      </button>
    })
  }

  render() {
    const translations = getTranslations()
    const settings = {
      dots: false,
      infinite: false,
      speed: 600,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
      ],
      nextArrow: <NextArrow/>,
      prevArrow: <PrevArrow/>
    }

    let headerTextKey = 'recommended-trip'; //translation key
    if (this.props.headerText !== '') {
      headerTextKey = this.props.headerText;
    }

    if (this.state.fetchError || !this.state.categories.length) {
      return ''
    }

    return (
      <div>
        <h2 className="header-medium color-dark text-center">
          {translations[headerTextKey]}
        </h2>
        <div className="categories">
          {this.renderCategories(translations)}
        </div>
        <div className="apartments">
          <div className={"apartments-carousel"}>
            <Slider className={"apartments-carousel-items"} {...settings}>
              {this.state.apartments.map(apartment => {
                  let apartmentQueryParams = {
                    ...this.state.queryParamsParsed
                  };

                  if (this.props.utmSource) {
                    apartmentQueryParams.utm_medium = 'polecane';
                    apartmentQueryParams.utm_campaign = 'polecane_apartamenty';
                    apartmentQueryParams.utm_source = this.props.utmSource;
                  }

                  let apartmentQueryString = qs.stringify(apartmentQueryParams);

                  return <ApartmentBox
                    key={apartment.id}
                    apartment={apartment}
                    translations={translations}
                    apartmentUrl={"/" + apartment.slug + '?' + apartmentQueryString}
                    carousel={false}
                    additionalClass={this.props.additionalClass}
                  />
                }
              )}
            </Slider>
          </div>
          <Preloader visible={this.state.isLoadingResults}/>
        </div>
      </div>
    );
  }
}
